import React, { useState } from "react";
import { View, StyleSheet, Text, Platform } from "react-native";

import ManaButton from "../../common/ManaButton";
import ManaTextInput from "../../common/ManaTextInput";
import Dialog from "../../common/dialog";
import AppTheme from "../../AppTheme";

export default function DeviceRenameDialog({
  device,
  rename = () => {},
  onClose = () => {},
}) {
  const [name, setName] = useState(device?.name);

  return device ? (
    <Dialog.Container
      onClose={onClose}
      showCloseButton
      headerStyle={{ margin: 0 }}
      contentStyle={{
        paddingVertical: 8,
        paddingHorizontal: 8,
      }}
    >
      <View style={styles.container}>
        <Text style={styles.label}>Current Name:</Text>
        <Text style={styles.name}>{device?.name}</Text>
        <Text style={styles.label}>Choose a new alias for the device:</Text>
        <ManaTextInput
          debounceDelay={500}
          style={styles.input}
          contentHeight={40}
          placeholderTextColor="#ABADB3"
          name={"deviceNameEdit"}
          placeholder="Enter new alias"
          onTextChanged={(text) => setName(text)}
          value={name || ""}
        />
      </View>

      {/* Buttons */}
      <View
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
          marginTop: 16,
        }}
      >
        <ManaButton
          style={styles.button}
          styleText={styles.buttonText}
          onPress={onClose}
          text="Back"
        />

        <ManaButton
          isMainButton
          disabled={!name}
          style={styles.button}
          styleText={styles.buttonText}
          onPress={() => rename(name)}
          text="Rename"
        />
      </View>
    </Dialog.Container>
  ) : null;
}

const styles = StyleSheet.create({
  label: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginBottom: 4,
  },
  name: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    marginBottom: 16,
  },
  input: {
    borderRadius: 4,
  },
  button: {
    width: "48%",
    height: 32,
    marginBottom: 8,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});
